<template>
	<div :class="from == 'anteprima' ? 'wiki-modal' : 'wiki'">
		<el-button
			@click="toggleSidebar(!sidebar_closed)"
			circle
			size="mini"
			style="margin-top: 10px; margin-left: -20px"
		>
			<md-icon v-if="!sidebar_closed">keyboard_double_arrow_right</md-icon>
			<md-icon v-if="sidebar_closed">keyboard_double_arrow_left</md-icon>
		</el-button>
		<div :style="{ width: sidebar_closed ? '' : '300px', display: 'flex' }">
			<div v-if="!sidebar_closed" style="margin: 10px">
				<strong>{{ $t("compile-wiki") }}</strong>
			</div>
		</div>
		<div
			style="margin: 10px; word-wrap: anywhere; overflow-y: scroll; height: 70%"
			v-html="sidebar_content ? sidebar_content : $t('click-wiki')"
			v-if="!sidebar_closed"
		/>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
	name: "fill-sidebar",
	props: ["from"],
	computed: {
		...mapGetters({
			sidebar_closed: "documents/sidebar",
			sidebar_content: "documents/sidebar_content"
		})
	},
	methods: {
		...mapMutations({
			toggleSidebar: "documents/TOGGLE_SIDEBAR",
			setSidebar: "documents/SIDEBAR_CONTENT"
		})
	}
}
</script>

<style scoped lang="scss">
.wiki {
	position: fixed;
	right: 0px;
	max-width: 300px;
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	background-color: #ddd !important;
	transition: width 0.5s;
	height: 80vh;
	border-radius: 0 0 0 25px;
}

.wiki-modal {
	max-width: 300px;
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	background-color: #ddd !important;
	transition: width 0.5s;
	height: 80vh;
	border-radius: 0 0 0 25px;
}
</style>
